import styled from "styled-components";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select  from '@mui/material/Select';
import { useState,useEffect } from 'react'

const Container=styled.div`
   
 `;


 export default function OptionFilter(props){
 	let { items,label,setFiltro }=props;
 	let [option,setOption]=useState(1);



 	let handleChange=(e,newValue)=>{
 			setOption(newValue.props.value)
 	};


 	useEffect(()=>{
 		setFiltro(Number(option))
 	},[option,setFiltro]);

 	return(
 		<Container>
 			<Box sx={{ minWidth: 120 }}>
      			<FormControl size="small">
        				<InputLabel id={label}>{label}</InputLabel>
        						<Select
          								id={label}
          								value={option}
										label={label}
          								onChange={handleChange}
        						>
          {items.map((item)=>(<MenuItem  key={ item.value} value={item.value}>{item.label}</MenuItem>))}
          
         
         
        </Select>
      </FormControl>
    </Box>
 		</Container>


 		)
 }